import { Component, HostBinding, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivityReportName, ANALYTICS, AnalyticsEvent, IAnalyticsService } from '@libs/portal-common/services';
import { routerTransition } from '@libs/portal-common/system';

import { ActivityGridComponent } from '../activity-grid/activity-grid.component';
import { ActivityFilter } from '../services/call-history.service';

@Component({
  selector: 'app-agent-activity',
  templateUrl: './agent-activity.component.html',
  animations: [routerTransition],
})
export class AgentActivityComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = '';
  @ViewChild(ActivityGridComponent) activityGrid: ActivityGridComponent;

  filter: ActivityFilter;

  constructor(@Inject(ANALYTICS) private analytcis: IAnalyticsService) {}

  ngOnInit() {
    let filter = new ActivityFilter();
    this.filter = filter;
    this.analytcis.track(AnalyticsEvent.DailyActivityOpen, { ReportName: ActivityReportName.AgentActivity });
  }

  search(filter: ActivityFilter) {
    const nextFilter = Object.assign(new ActivityFilter(), filter);

    if (this.activityGrid) {
      if (nextFilter.RandomSampleEnabled) {
        this.activityGrid.state = {
          ...this.activityGrid.state,
          group: [],
          skip: 0,
        };
        this.activityGrid.groupable = false;
      } else {
        this.activityGrid.groupable = { showFooter: true };
      }
    }

    this.filter = nextFilter;
  }

  onFilterChange(filter: ActivityFilter) {
    this.filter = filter;
  }
}
